import { render } from "./MoustLeftButtonIcon.vue?vue&type=template&id=2896cb99"
import script from "./MoustLeftButtonIcon.vue?vue&type=script&lang=js"
export * from "./MoustLeftButtonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__